/**
 * Algemene themafunctionaliteit.
 *
 * Bewust klein gehouden: geen frameworks, geen externe bibliotheken.
 * Alles wat zonder JavaScript kan (uitklapmenu's, formulieren, links),
 * gebeurt ook zonder JavaScript.
 */
(function () {
  'use strict';

  // Voorkomt dubbele initialisatie wanneer dit bestand twee keer wordt ingeladen.
  if (window.__themeGlobal) return;
  window.__themeGlobal = true;

  /* ------------------------------------------------------------------
     Mobiel menu
     ------------------------------------------------------------------ */

  function initMobileMenu() {
    var menu = document.querySelector('[data-mobile-menu]');
    var toggle = document.querySelector('[data-menu-toggle]');
    if (!menu || !toggle) return;

    var lastFocused = null;

    function open() {
      lastFocused = document.activeElement;
      menu.classList.add('is-open');
      document.body.classList.add('menu-open');
      toggle.setAttribute('aria-expanded', 'true');

      var closeButton = menu.querySelector('[data-menu-close]');
      if (closeButton && closeButton.focus) closeButton.focus();
    }

    function close() {
      menu.classList.remove('is-open');
      document.body.classList.remove('menu-open');
      toggle.setAttribute('aria-expanded', 'false');
      if (lastFocused && lastFocused.focus) lastFocused.focus();
    }

    toggle.addEventListener('click', function () {
      if (menu.classList.contains('is-open')) {
        close();
      } else {
        open();
      }
    });

    menu.addEventListener('click', function (event) {
      if (event.target.closest('[data-menu-close]')) {
        event.preventDefault();
        close();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && menu.classList.contains('is-open')) close();
    });

    // Focus vasthouden binnen het paneel zolang het open is
    menu.addEventListener('keydown', function (event) {
      if (event.key !== 'Tab' || !menu.classList.contains('is-open')) return;

      var focusable = menu.querySelectorAll('a[href], button:not([disabled]), input, summary');
      if (!focusable.length) return;

      var first = focusable[0];
      var last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
  }

  /* ------------------------------------------------------------------
     Zoekbalk in de header
     ------------------------------------------------------------------ */

  function initSearch() {
    var toggle = document.querySelector('[data-search-toggle]');
    var panel = document.querySelector('[data-search-panel]');
    if (!toggle || !panel) return;

    toggle.addEventListener('click', function () {
      var isOpen = !panel.hidden;
      panel.hidden = isOpen;
      toggle.setAttribute('aria-expanded', String(!isOpen));

      if (!isOpen) {
        var input = panel.querySelector('input[type="search"]');
        if (input) input.focus();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !panel.hidden) {
        panel.hidden = true;
        toggle.setAttribute('aria-expanded', 'false');
        toggle.focus();
      }
    });
  }

  /* ------------------------------------------------------------------
     Uitklapmenu's in de desktopnavigatie sluiten bij klik daarbuiten
     ------------------------------------------------------------------ */

  function initNavDropdowns() {
    document.querySelectorAll('[data-nav-toggle]').forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        var dropdown = toggle.closest('[data-nav-dropdown]');

        // Op desktop doet hoveren al het werk; dit knopje is daar alleen
        // decoratief. Alleen in het mobiele menu schakelt het echt iets.
        if (!dropdown.classList.contains('mobile-menu__group')) return;

        var isOpen = dropdown.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      document.querySelectorAll('[data-nav-dropdown][open]').forEach(function (details) {
        details.open = false;
        var summary = details.querySelector('summary');
        if (summary) summary.focus();
      });
    });
  }

  /* ------------------------------------------------------------------
     Filterknoppen op de homepage
     ------------------------------------------------------------------ */

  function initSeriesFilters() {
    document.querySelectorAll('[data-series-filters]').forEach(function (group) {
      var section = group.closest('section') || document;
      var grid = section.querySelector('[data-series-grid]');
      if (!grid) return;

      var buttons = group.querySelectorAll('[data-filter]');

      buttons.forEach(function (button) {
        button.addEventListener('click', function () {
          var selected = button.dataset.filter;

          buttons.forEach(function (other) {
            other.setAttribute('aria-pressed', String(other === button));
          });

          grid.querySelectorAll('[data-series]').forEach(function (item) {
            var visible = selected === 'all' || item.dataset.series === selected;
            item.hidden = !visible;
          });
        });
      });
    });
  }

  /* ------------------------------------------------------------------
     Land- en taalkiezer
     ------------------------------------------------------------------ */

  function initLocalization() {
    document.querySelectorAll('[data-localization-select]').forEach(function (select) {
      select.addEventListener('change', function () {
        var form = select.closest('form');
        if (form) form.submit();
      });
    });
  }

  /* ------------------------------------------------------------------
     Deelknop
     ------------------------------------------------------------------ */

  function initShare() {
    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-share-button]');
      if (!button) return;

      var url = button.dataset.shareUrl || window.location.href;

      if (!navigator.clipboard) return;

      navigator.clipboard.writeText(url).then(function () {
        var original = button.textContent;
        button.textContent = window.theme.strings.copied;
        setTimeout(function () { button.textContent = original; }, 1800);
      });
    });
  }

  /* ------------------------------------------------------------------
     Aanbevolen producten laden
     ------------------------------------------------------------------ */

  function initRecommendations() {
    document.querySelectorAll('[data-recommendations]').forEach(function (container) {
      if (container.dataset.loaded) return;
      container.dataset.loaded = 'true';

      var url = container.dataset.url;
      if (container.dataset.intent) url += '&intent=' + container.dataset.intent;

      fetch(url)
        .then(function (response) { return response.text(); })
        .then(function (html) {
          var parsed = new DOMParser().parseFromString(html, 'text/html');
          var incoming = parsed.querySelector('[data-recommendations]');
          if (incoming && incoming.innerHTML.trim()) {
            container.innerHTML = incoming.innerHTML;
          }
        })
        .catch(function () {});
    });
  }

  /* ------------------------------------------------------------------
     Aantalkiezer

     Via event-delegatie op document-niveau, zodat de knoppen overal werken:
     productpagina, winkelmandpagina en het zijpaneel. Ook na het vervangen
     van HTML door de Section Rendering API blijven ze werken, zonder dat er
     opnieuw geinitialiseerd hoeft te worden.
     ------------------------------------------------------------------ */

  function initQuantityButtons() {
    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-quantity-decrease], [data-quantity-increase]');
      if (!button) return;

      var wrapper = button.closest('.quantity-input');
      var input = wrapper && wrapper.querySelector('[data-quantity-input]');
      if (!input) return;

      var direction = button.hasAttribute('data-quantity-increase') ? 1 : -1;
      var current = parseInt(input.value, 10);
      if (isNaN(current)) current = 1;

      var min = parseInt(input.min, 10);
      if (isNaN(min)) min = 1;

      var max = input.max === '' ? null : parseInt(input.max, 10);
      var next = current + direction;

      if (next < min) next = min;
      if (max !== null && !isNaN(max) && next > max) next = max;
      if (next === current) return;

      input.value = next;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  /* ------------------------------------------------------------------
     Initialisatie
     ------------------------------------------------------------------ */

  var delegatesBound = false;

    function init() {
    initSeriesFilters();
    initLocalization();
    initRecommendations();

    // Deze knoppen horen bij de header, die niet opnieuw laadt wanneer je
    // een andere sectie bewerkt. Eenmalig koppelen voorkomt dat een knop na
    // een tijdje 'dubbel' reageert: aan- en in dezelfde klik meteen weer
    // uitschakelen, zodat het lijkt alsof er niets gebeurt.
    if (!delegatesBound) {
      delegatesBound = true;
      initMobileMenu();
      initSearch();
      initNavDropdowns();
      initShare();
      initQuantityButtons();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // De Theme Editor herlaadt secties zonder paginaverversing.
  document.addEventListener('shopify:section:load', init);
})();
